import { isToday, format } from 'date-fns';
import { type MessageForPreview } from './types';

export const formatMessageTime = (message?: MessageForPreview | null) => {
  const time = message?.created_at;
  let formattedTime = '';
  if (time) {
    const date = new Date(time);
    if (!Number.isNaN(date.getTime())) {
      formattedTime = isToday(date) ? format(date, 'HH:mm') : format(date, 'd MMM');
    }
  }
  return formattedTime;
};
